module.exports = __webpack_public_path__ + "img/booth-front.ff78a1af.jpg";